import React, { useState } from 'react';
import {
  useFieldArray,
  UseFieldArrayReturn,
  useFormContext,
} from 'react-hook-form';
import { DataExtractionTemplateState } from '../../../DataExtractionTemplate';
import ConfirmationDialog from '../../ConfirmationDialog';
import AddOutcome from '../AddOutcome/AddOutcome';
import * as outcomeStyles from '../OutcomesPanel.module.scss';
import OutcomeEditor from '../OutcomeEditor';
import { Accordion } from 'components/core';
import { OutcomeTypes } from 'types/DataExtraction';

type Props = {
  resultsDataAnchor?: string;
  fullWidth?: boolean;
};

const OutcomesList = ({ resultsDataAnchor, fullWidth = false }: Props) => {
  const [modal, setModal] = useState<React.ReactElement | null>();
  const { getValues, formState } = useFormContext();
  const outcomes = useFieldArray<DataExtractionTemplateState>({
    name: 'outcomes.outcomes',
  }) as UseFieldArrayReturn<DataExtractionTemplateState, 'outcomes.outcomes'>;

  const onAddOutcome = () => {
    outcomes.append({
      name: '',
      outcome_type: OutcomeTypes.CONTINUOUS,
      timepoints: [{ name: 'End of study' }],
      has_extracted_data: false,
    });
  };

  return (
    <div className={fullWidth ? '' : outcomeStyles.outcomesListRestrictedWidth}>
      {modal}
      <Accordion allowMultiple={false}>
        {outcomes.fields.map((field, index) => {
          return (
            <OutcomeEditor
              key={field.id}
              index={index}
              resultsDataAnchor={resultsDataAnchor}
              hasExtractedData={field.has_extracted_data}
              onDelete={() => {
                const { id, has_extracted_data } = getValues(
                  `outcomes.outcomes.${index}`
                );

                if (id && has_extracted_data) {
                  setModal(
                    <ConfirmationDialog
                      onConfirm={() => outcomes.remove(index)}
                      onClose={() => setModal(null)}
                    />
                  );
                } else {
                  outcomes.remove(index);
                }
              }}
            />
          );
        })}
      </Accordion>

      <AddOutcome
        onClick={onAddOutcome}
        disabled={!formState.isValid}
        length={outcomes.fields.length}
      />
    </div>
  );
};

export default OutcomesList;
